import {Reducer} from 'redux';
import {MessageActionTypes, MessageState, SET_MESSAGE} from '../action/messageAction';

const initialState: MessageState = {
    message: null
};

const messageReducer: Reducer<MessageState, MessageActionTypes> = (state = initialState, action) => {
    switch (action.type) {
        case SET_MESSAGE: {
            return {
                message: action.payload
            };
        }
    }
    return state;
};

export default messageReducer;
